import React from "react";
import { Box, Container, Typography, useTheme} from "@mui/material";
import FacilityManagmemt from "../assets/FacilityManagmemt.png";

export default function FacilityManagement() {
  const theme = useTheme();

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#fff" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 6, md: 8 },
        }}
      >
        {/* === Left Image Section === */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={FacilityManagmemt}
            alt="Facility Management Visual"
            sx={{
              width: { xs: "85%", sm: "75%", md: "100%" },
              maxWidth: 520,
              borderRadius: 0,
              boxShadow: "none",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* === Right Text Section === */}
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
            maxWidth: 600,
          }}
        >
          <Typography
            variant="h4"
            fontWeight={800}
            mb={2}
            sx={{
              background: "linear-gradient(90deg, #1565c0, #004ba0)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            What is Namami’s Facility Management?
          </Typography>

          <Typography
            variant="h6"
            color="primary"
            mb={2}
            sx={{  opacity: 0.9 }}
          >
            (NAMAMI Integrated Facilities Management)
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 3,
              lineHeight: 1.7,
              fontSize: "1.05rem",
            }}
          >
            “NAMAMI Integrated Facilities Management is the set of processes within
            an organization designed to maintain and develop agreed services that
            support and improve the efficiency of its primary (Core Function) activities.”
          </Typography>

          {/* === Bullet Points === */}
          <Box
            component="ul"
            sx={{
              listStyle: "none",
              pl: 0,
              mt: 3,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {[
              "High Standards of Service Delivery",
              "Single Window Delivery Accountability",
              "Cost Efficient – High Quality Control and Management Service",
              "Site-specific, Man & Machine Combined Optimized Solutions",
            ].map((point, index) => (
              <Typography
                key={index}
                component="li"
                variant="body1"
                color="text.secondary"
                sx={{
                  mb: 1.2,
                  "&::before": {
                    content: '"✓"',
                    color: theme.palette.primary.main,
                    fontWeight: "bold",
                    marginRight: "8px",
                  },
                }}
              >
                {point}
              </Typography>
            ))}
          </Box>

          {/* === Subtext / Summary === */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 4,
              lineHeight: 1.7,
              fontSize: "0.98rem",
            }}
          >
            At <strong>Namami India Support Services</strong>, our facility management
            philosophy is built on efficiency, accountability, and technological innovation.
            We ensure optimized service delivery across every project by combining manpower
            expertise with modern management systems.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
